import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

import { formatDateTime, formatDate } from '../../../Utils/GlobalUtils';
import { useTimeModal } from '../../TimeModal/TimeModalContext';

import Loading from '../../Loading';
import LoadingLines from '../../LoadingLines';
import WarningPanel from '../../WarningPanel';
import ViewFileById from '../../ViewFileById';

import IconContainer from '../../IconContainer';
import { ReactComponent as ReloadIcon } from '../../../icons/reload.svg';

const SROFinancialStatements = () => {
  const { openTimeModal } = useTimeModal;
  const navigate = useNavigate();
  const location = useLocation();

  const [cases, setCases] = React.useState([]);
  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    setLoading(true);

    axios.get(`/api/get-all-sro-financial-statements`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    .then((response) => {
      setWarning('');
      setCases(response.data);
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    });
  }, [reload]);

  const [confirmDeleteId, setConfirmDeleteId] = React.useState(null);
    
  React.useEffect(() => {
    if (confirmDeleteId !== null) {
      const timeout = setTimeout(() => setConfirmDeleteId(null), 3000);
      return () => clearTimeout(timeout);
    }
  }, [confirmDeleteId]);


  return (
    <>
        {/* {isModal && <AddNewSpecialDebtorCategory closeModal={() => setIsModal(false)} onReloadTable={() => setReload(true)} />}
        {isDeleteModal && <DeleteSDC closeModal={() => setIsDeleteModal(false)} handleChangeIsActive={() => handleChangeIsActive(currentId)} />} */}

        <div className='tableContainer'>
            <div className='tableHeaderWrapper'>
            <div className='tableStatus'>
                <div>
                    <p>Всего ведомостей: {cases.length}</p>
                </div>
                <a className='lastUpdateWrapper'>
                    {loading ? 
                        <Loading type='inline' /> 
                    : 
                        <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                    }
                </a>
            </div>
            <div className='tableHeader' style={{ gridTemplateColumns: '70fr 10fr 20fr' }}>
                <div>Период</div>
                <div>Файл</div>
                <div>Дата и время объединения</div>
            </div>
            </div>
            {(cases.length==0 && loading) ? <LoadingLines />
            : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
            : cases.map((caseItem) => (
                <div 
                  className='tableRow nonActive' 
                  style={{ gridTemplateColumns: '70fr 10fr 20fr' }}
                  key={caseItem.id}
                >
                  <div>
                    <p>{formatDate(caseItem.date_start)+'-'+formatDate(caseItem.date_end)}</p>
                  </div>
                  <div>
                    <ViewFileById fileId={caseItem.file_id} />
                  </div>
                  <div>
                    <p>{formatDateTime(caseItem.created_at)}</p>
                  </div>
                </div>
            ))}
        </div>
    </>
  )
}

export default SROFinancialStatements;